import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { UserTokenService } from "src/app/core/services/user-token.service";

@Component({
    selector: 'dashboard-home',
    templateUrl: './dashboard-home.component.html',
    styleUrls: ['./dashboard-home.component.scss']
  })




  export class DashboardHomeComponent implements OnInit {

    public type: string = "";
    public isClient: boolean = false;
    public isService: boolean = false;
    public isAdmin: boolean = false;


    constructor(private userTokenService: UserTokenService,
                private router: Router)
    { }

    ngOnInit(): void {

        console.log("DashboardHomeComponent - ngOnInit");
        console.log(this.userTokenService.hasPermissionArray(['HOME_CARTORIO_ADMIN']));
        console.log(this.userTokenService.hasPermissionArray(['HOME_CARTORIO_SERVICE']));
        console.log(this.userTokenService.hasPermissionArray(['HOME_CARTORIO_CLIENT']));

        if (this.userTokenService.hasPermissionArray(['HOME_CARTORIO_ADMIN']) || this.userTokenService.hasPermissionArray(['SF_ADMIN'])){
            this.router.navigate(['/home/admin']);
        }else if (this.userTokenService.hasPermissionArray(['HOME_CARTORIO_SERVICE'])){
            this.router.navigate(['/home/service']);
        }else if (this.userTokenService.hasPermissionArray(['HOME_CARTORIO_CLIENT'])){
            this.router.navigate(['/home/client']);
        }else{
            this.router.navigate(['/home/client']);
        }

    }
}
